<!------------ START TEMPLATE ------------>
<template>
  <div class="gap-2 flex">
    <div class="vx-col w-1/3 gap-2">
      <vx-card class="mb-2" title="Filtros">
        <div class="flex justify-start gap-4 row">
          <div class="w-1/2">
            <span class="pl-2">Mês</span>
            <v-select
              :options="mesesSelect"
              class="w-full"
              name="Mes Filtro Meta"
              id="Mes Filtro Meta"
              v-model="mesFiltroNovaMeta"
            />
          </div>
          <div class="w-1/2 pb-2">
            <span class="pl-2">Ano</span>
            <v-select
              :options="anosSelect"
              class="w-full"
              name="Ano Filtro Meta"
              id="Ano Filtro Meta"
              v-model="anoFiltroNovaMeta"
            />
          </div>
        </div>
        <div class="row">
          <span class="pl-2">Regional</span>
          <v-select
            :options="regionais"
            name="Regional"
            id="Regional"
            v-model="regionalFiltro"
          ></v-select>
        </div>
        <div class="flex row gap-2 justify-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            class="mt-3 w-1/2"
            @click="filtroBuscaDadosMetas"
            >Filtrar</vs-button
          >

          <vs-button
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="mt-3 w-1/2"
            @click="modalCadastroMetas"
            >Nova Meta</vs-button
          >
        </div>
      </vx-card>

      <vx-card>
        <div>
          <h5>{{ this.regionalTituloGrafico }}</h5>
        </div>
        <vs-divider />
        <table class="w-full table-total">
          <tr>
            <th class="text-center">Propostas</th>
            <th class="text-center">Quantidade</th>
            <th class="text-center">Total</th>
          </tr>
          <tr v-for="element of resultadosGerais" v-bind:key="element.id">
            <td class="text-center">
              <p>
                {{
                  element.tipoproposta === 'Adesão'
                    ? 'Contratação'
                    : element.tipoproposta
                }}
              </p>
            </td>
            <td class="text-center">
              <p>{{ element.qtd }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td class="text-center">
              <p>{{ valueTotal }}</p>
            </td>
          </tr>
        </table>
        <vs-divider />
      </vx-card>
    </div>

    <div class="justify-between gap-2 vx-col w-2/3">
      <vx-card>
        <div class="mb-3">
          <h5>CONSULTORES - {{ this.regionalTituloGrafico }}</h5>
        </div>
        <vs-table
          noDataText="Nenhum Consultor Encontrado"
          ref="table"
          v-model="selected"
          pagination
          :max-items="itemsPerPage"
          search
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <!------------ START ITENS POR PÁGINA ------------>
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    itens.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : itens.length
                  }}
                  de {{ itens.length }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <!------------ END ITENS POR PÁGINA ------------>

          <!------------ START TITULO DA TABELA ------------>

          <template slot="thead">
            <vs-th sort-key="Nome">Nome</vs-th>
            <vs-th sort-key="Usuario">Regional</vs-th>
            <vs-th sort-key="Resultado">Resultado</vs-th>
            <vs-th sort-key="Meta">Meta</vs-th>
          </template>
          <!------------ END TITULO DA TABELA ------------>

          <!------------ START TABELA ------------>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                :state="
                  tr.propostasFinalizadas >
                  (tr.novameta ? tr.novameta : tr.metapadrao)
                    ? 'success'
                    : null
                "
              >
                <vs-td>
                  <vs-list-item :title="tr.nome">
                    <template slot="avatar">
                      <vs-avatar />
                    </template>
                  </vs-list-item>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ tr.regional }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category flex justify-center">
                    {{ tr.propostasFinalizadas }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category flex justify-center">
                    {{ tr.novameta ? tr.novameta : tr.metapadrao }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <!------------ END TABELA ------------>
      </vx-card>
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
    </div>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados do Consultor`"
      @close="popupActive = false"
    />
    <vs-popup title="Definir Nova Meta" :active.sync="popupActivo">
      <form role="form" @submit.stop.prevent="onSubmit">
        <div class="gap-2">
          <span>Regional</span>
          <v-select
            :options="regionais"
            name="Regional"
            id="Regional"
            v-model="objNovaMeta.idRegionalNovaMeta"
            v-validate="{ required: true }"
            :state="validateState('Regional')"
            :danger="validateClass('Regional')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          ></v-select>
        </div>
        <div class="mt-2">
          <span>Tipos das Propostas</span>
          <v-select
            :options="arrTtiposProposta"
            multiple
            name="Tipos Propostas"
            id="Tipos Propostas"
            v-model="objNovaMeta.tipoProposta"
            v-validate="{ required: true }"
            :state="validateState('Tipos Propostas')"
            :danger="validateClass('Tipos Propostas')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          ></v-select>
        </div>
        <div class="flex row gap-2 mt-2">
          <div class="w-1/2">
            <span>Mês Nova Meta</span>
            <v-select
              :options="mesesSelect"
              class="w-full"
              name="MesNovaMetaId"
              id="MesNovaMetaId"
              v-model="objNovaMeta.mesNovaMeta"
              v-validate="{ required: true }"
              :state="validateState('MesNovaMetaId')"
              :danger="validateClass('MesNovaMetaId')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="w-1/2">
            <span>Ano Nova Meta</span>
            <v-select
              :options="anosSelect"
              class="w-full"
              name="AnoNovaMeta"
              id="AnoNovaMeta"
              v-model="objNovaMeta.anoNovaMeta"
              v-validate="{ required: true }"
              :state="validateState('AnoNovaMeta')"
              :danger="validateClass('AnoNovaMeta')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="mt-2">
          <span>Nova Meta</span>
          <vs-input
            type="number"
            class="w-full"
            name="Meta"
            v-model="objNovaMeta.novaMeta"
            v-validate="{ required: true }"
            :state="validateState('Meta')"
            :danger="validateClass('Meta')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="flex justify-end pt-4">
          <vs-button color="success" type="gradient" text-color="Registrar"
            >Registrar</vs-button
          >
        </div>
        <vs-alert
          v-if="$validator.errors.all().length > 0"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li
              class="mb-2"
              v-for="error in $validator.errors.all()"
              :key="error.id"
            >
              {{ error }}
            </li>
          </ul>
        </vs-alert>
      </form>
    </vs-popup>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from '../../../services';
import vSelect from 'vue-select';
import jwt from 'jsonwebtoken';
import ModalInfo from '../../../components/ModalInfo';
import locale from '../../../locale';
import { decryptData } from '../../../services/decryptData';

export default {
  components: {
    'v-select': vSelect,
    ModalInfo,
  },
  props: ['subjectPermission'],
  data() {
    return {
      resultadosGerais: [],
      selectedTr: null,
      mesesSelect: [
        {
          label: 'Janeiro',
          id: '01',
        },
        {
          label: 'Fevereiro',
          id: '02',
        },
        {
          label: 'Março',
          id: '03',
        },
        {
          label: 'Abril',
          id: '04',
        },
        {
          label: 'Maio',
          id: '05',
        },
        {
          label: 'Junho',
          id: '06',
        },
        {
          label: 'Julho',
          id: '07',
        },
        {
          label: 'Agosto',
          id: '08',
        },
        {
          label: 'Setembro',
          id: '09',
        },
        {
          label: 'Outubro',
          id: '10',
        },
        {
          label: 'Novembro',
          id: '11',
        },
        {
          label: 'Dezembro',
          id: '12',
        },
      ],
      anosSelect: [],
      mesFiltroNovaMeta: null,
      anoFiltroNovaMeta: null,
      regionalFiltro: null,
      objNovaMeta: {
        novaMeta: null,
        mesNovaMeta: null,
        anoNovaMeta: null,
        idRegionalNovaMeta: null,
        tipoProposta: '',
      },
      arrTtiposProposta: [
        'Contratação',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      modalSelecionado: [],
      popupActive: false,
      regionalTituloGrafico: null,
      idEmpresa: null,
      isAdmin: false,
      controllerGeral: 'Usuario',
      consultores: [],
      selected: [],
      regionais: [],
      itens: [],
      itemsPerPage: 5,
      isMounted: false,
      popupActivo: false,
      idRegional: null,
      decoded: null,
      valueTotal: 0,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    modalCadastroMetas() {
      this.popupActivo = !this.popupActivo;
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.idEmpresa = this.decoded.id_empresa;
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    montaArrayAno() {
      const anoAnterior = new Date().getFullYear() - 1;
      this.anosSelect.push(anoAnterior);
      const anoAtual = new Date().getFullYear();
      this.anosSelect.push(anoAtual);
      const proxAno = new Date().getFullYear() + 1;
      this.anosSelect.push(proxAno);
    },
    async onSubmit() {
      let objSend = {};

      this.$validator.validateAll().then((result) => {
        if (result) {
          objSend = this.formataDados(objSend);
          this.$vs.loading();
          service
            .post('Usuario', 'inserirMeta', objSend)
            .then((res) => {
              if (res) {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `Operação Realizada com sucesso`,
                  color: 'success',
                });
                this.modalCadastroMetas();
                this.$vs.loading.close();
              }
            })
            .catch((error) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        }
      });
    },
    formataDados(obj) {
      obj.idRegionalNovaMeta = this.objNovaMeta.idRegionalNovaMeta.id;
      obj.tipoProposta = this.objNovaMeta.tipoProposta.toString();
      obj.mesNovaMeta = this.objNovaMeta.mesNovaMeta.id;
      obj.anoNovaMeta = this.objNovaMeta.anoNovaMeta.toString();
      obj.novaMeta = parseInt(this.objNovaMeta.novaMeta);
      obj.idEmpresaNovaMeta = localStorage.getItem('idEmpresa');

      if (obj.tipoProposta === 'Contratação') {
        obj.tipoProposta = 'Adesão';
      }

      return obj;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });
        });
    },
    somaTotalQtdPropostas(array) {
      this.valueTotal = 0;
      this.valueTotal = array.reduce((accumulator, currentValue) => {
        accumulator = accumulator + currentValue.qtd;
        return accumulator;
      }, 0);
      return this.valueTotal;
    },
    async filtroBuscaDadosMetas() {
      this.resultadosGerais = [];

      let objSend = {};
      if (
        this.regionalFiltro &&
        this.anoFiltroNovaMeta &&
        this.mesFiltroNovaMeta
      ) {
        objSend.idRegional = this.regionalFiltro.id;
        objSend.mes = this.mesFiltroNovaMeta.id;
        objSend.ano = this.anoFiltroNovaMeta;

        this.$vs.loading();
        await service
          .post(this.controllerGeral, 'listar-metas-consultores', objSend)
          .then((res) => {
            this.itens = [];
            res.data.list.forEach((element) => {
              if (element.consultor == true && element.deletedAt == null) {
                if (element.Usuarios_Regional) {
                  element.idRegional = element.Usuarios_Regional.id;
                }
                if (element.Usuarios_Regional) {
                  element.nomeRegional = element.Usuarios_Regional.nome;
                }
                this.itens.push(element);
              }
            });
            res.data.count.forEach((element) => {
              if (element.tipoproposta == 'Adesão') {
                this.resultadosGerais[0] = {
                  ...element,
                };
              }
              if (element.tipoproposta == 'Inclusão') {
                this.resultadosGerais[1] = {
                  ...element,
                };
              }
              if (element.tipoproposta == 'Reativação') {
                this.resultadosGerais[2] = {
                  ...element,
                };
              }
              if (element.tipoproposta == 'Substituição') {
                this.resultadosGerais[3] = {
                  ...element,
                };
              }
            });
            this.somaTotalQtdPropostas(this.resultadosGerais);
            this.regionalTituloGrafico = this.itens[0].regional;
            this.$vs.loading.close();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Preencha os dados do filtro',
          color: 'danger',
        });
      }
    },
    async buscaDados() {
      let objSend = {};
      this.resultadosGerais = [];

      objSend.idEmpresa = localStorage.getItem('idEmpresa');
      objSend.idRegional = this.decoded.id_regional;
      objSend.mes = new Date().getMonth();
      objSend.ano = new Date().getFullYear();

      this.$vs.loading();
      service
        .post(this.controllerGeral, 'listar-metas-consultores', objSend)
        .then((res) => {
          this.itens = [];
          res.data.list.forEach((element) => {
            if (element.consultor == true && element.deletedAt == null) {
              if (element.Usuarios_Regional) {
                element.idRegional = element.Usuarios_Regional.id;
              }
              if (element.Usuarios_Regional) {
                element.nomeRegional = element.Usuarios_Regional.nome;
              }
              this.itens.push(element);
            }
          });
          res.data.count.forEach((element) => {
            if (element.tipoproposta == 'Adesão') {
              this.resultadosGerais[0] = {
                ...element,
              };
            }
            if (element.tipoproposta == 'Inclusão') {
              this.resultadosGerais[1] = {
                ...element,
              };
            }
            if (element.tipoproposta == 'Reativação') {
              this.resultadosGerais[2] = {
                ...element,
              };
            }
            if (element.tipoproposta == 'Substituição') {
              this.resultadosGerais[3] = {
                ...element,
              };
            }
          });
          this.somaTotalQtdPropostas(this.resultadosGerais);
          this.regionalTituloGrafico = this.itens[0].regional;
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Nenhum Registro Encontrado',
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
  },
  created() {
    this.getDecoded();
    this.buscaDados();
    this.$validator.localize('ptBr', locale);
    this.montaArrayAno();
  },
  mounted() {
    this.buscaDadosSelects('regionais', 'regionais', 'nome', 'idRegional');
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
.table-total {
  tr:nth-child(odd) {
    background-color: #edf4fb;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table--thead {
      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }
  }
}
</style>

<!------------ END STYLE ------------>
